var _g, _path, _path2, _path3, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneExpiredIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 79,
    viewBox: "0 0 61 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_668_13349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 63.751H2V72.751H48V63.751Z",
    fill: "#ED8044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 2.75098H2V10.751H48V2.75098Z",
    fill: "#ED8044"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.001 1.5H5.00098C3.06798 1.5 1.50098 3.067 1.50098 5V70C1.50098 71.933 3.06798 73.5 5.00098 73.5H45.001C46.934 73.5 48.501 71.933 48.501 70V5C48.501 3.067 46.934 1.5 45.001 1.5Z",
    stroke: "#1E1E1E",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.53809 12.184H47.5011",
    stroke: "#1E1E1E",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.53809 62.915H47.5011",
    stroke: "#1E1E1E",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.913 42.227C16.913 38.291 11.185 39.539 11.185 37.299C11.185 36.387 11.841 35.955 12.721 35.987C13.681 36.003 14.273 36.579 14.321 37.315H16.785C16.641 35.299 15.073 34.131 12.785 34.131C10.481 34.131 8.84898 35.347 8.84898 37.363C8.83298 41.411 14.593 39.955 14.593 42.371C14.593 43.171 13.969 43.731 12.913 43.731C11.873 43.731 11.281 43.139 11.217 42.243H8.81698C8.84898 44.355 10.641 45.571 12.961 45.571C15.505 45.571 16.913 43.987 16.913 42.227ZM18.855 45.459H21.095V38.195L24.103 45.459H25.799L28.791 38.195V45.459H31.031V34.291H28.503L24.951 42.595L21.399 34.291H18.855V45.459ZM41.0536 42.227C41.0536 38.291 35.3256 39.539 35.3256 37.299C35.3256 36.387 35.9816 35.955 36.8616 35.987C37.8216 36.003 38.4136 36.579 38.4616 37.315H40.9256C40.7816 35.299 39.2136 34.131 36.9256 34.131C34.6216 34.131 32.9896 35.347 32.9896 37.363C32.9736 41.411 38.7336 39.955 38.7336 42.371C38.7336 43.171 38.1096 43.731 37.0536 43.731C36.0136 43.731 35.4216 43.139 35.3576 42.243H32.9576C32.9896 44.355 34.7816 45.571 37.1016 45.571C39.6456 45.571 41.0536 43.987 41.0536 42.227Z",
    fill: "#1E1E1E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.165 75.9692C52.6843 75.9692 57.9692 70.6843 57.9692 64.165C57.9692 57.6457 52.6843 52.3608 46.165 52.3608C39.6457 52.3608 34.3608 57.6457 34.3608 64.165C34.3608 70.6843 39.6457 75.9692 46.165 75.9692Z",
    fill: "#ED8044"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.512 57.3776H48.0532L47.0414 66.8209H45.0179L44.512 57.3776Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9356 69.7132C47.9356 70.6911 47.1429 71.4838 46.165 71.4838C45.1871 71.4838 44.3944 70.6911 44.3944 69.7132C44.3944 68.7353 45.1871 67.9426 46.165 67.9426C47.1429 67.9426 47.9356 68.7353 47.9356 69.7132Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.165,
    cy: 64.165,
    r: 12.665,
    stroke: "#1E1E1E",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_668_13349"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneExpiredIcon);
export default __webpack_public_path__ + "static/media/PhoneExpiredIcon.e54bff5906b31b70dba0bb329aabdf09.svg";
export { ForwardRef as ReactComponent };